import { render, staticRenderFns } from "./classInfo.vue?vue&type=template&id=a5db5fc4&scoped=true&"
import script from "./classInfo.vue?vue&type=script&lang=js&"
export * from "./classInfo.vue?vue&type=script&lang=js&"
import style0 from "./classInfo.vue?vue&type=style&index=0&id=a5db5fc4&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a5db5fc4",
  null
  
)

export default component.exports